export const ADMIN_EMAILS = [
  "suyash.shinde@wokelo.ai",
  "abhimanyu.kakkar@wokelo.ai",
  "sid@wokelo.ai",
];

export function isAdminEmail(email) {
  if (!email) return false;
  return ADMIN_EMAILS.some(e => e.toLowerCase() === email.toLowerCase());
}
